// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"562":"af561a3b","641":"af561a3b"}[chunkId] + ".chunk.css";
};